<app-button
  variant="ghost"
  class="ord-modal-button-close"
  svgIcon="close"
  ariaLabel="Close"
  (btnClick)="closeDialog()"
/>
<h2 mat-dialog-title class="ord-modal-title">
  <mat-icon
    svgIcon="error"
    class="ord-icon ord-icon-lg ord-text-red"
  ></mat-icon>
  <span>You are Offline</span>
</h2>
<mat-dialog-content class="ord-modal-content">
  @if (showCacheError) {
    <div class="bg-red-50 border-l-4 border-red-400 p-3 mb-3">
      <p class="text-sm font-semibold mb-1 text-red-700">Unable to load POS page</p>
      <p class="text-sm text-red-600">The POS page has not been cached for offline use. Please reconnect to the internet and visit the POS page at least once to enable offline access.</p>
    </div>
  } @else {
    <p class="mb-3">You are currently offline. You can only use the Point of Sale (POS) system while offline.</p>

    <div class="bg-blue-50 border-l-4 border-blue-400 p-3 mb-3">
      <p class="text-sm font-semibold mb-1">Note:</p>
      <p class="text-sm">POS data is automatically cached when you're online. If this is your first time going offline, make sure you visited the POS page while connected to the internet.</p>
    </div>
  }

  <p class="text-sm text-gray-600">Other features will be available when you're back online.</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="ord-modal-actions">
  @if (showCacheError) {
    <app-button
      variant="secondary"
      (btnClick)="closeDialog()"
    >
      <ng-template appButtonText> Close </ng-template>
    </app-button>
  } @else {
    <app-button
      variant="primary"
      (btnClick)="goToPos()"
    >
      <ng-template appButtonText> Go to POS </ng-template>
    </app-button>
  }
</mat-dialog-actions>